import { useCallback } from 'react';
import { EecLabelSectionDE } from '~/app/compositions/content/eec/eec-label-section-de';
import { EecLabelSectionDefault } from '~/app/compositions/content/eec/eec-label-section-default';
import { AEM_MARKET_CONFIG, WltpInfo } from '~/app/market-config';
import { appTrackingService } from '~/app/tracking/app-tracking-service';
import { useConfigurator } from '~/graphql/hooks/use-configurator';

interface EecLabelSectionProps {
	url?: string;
	pdfURL?: string;
	eecURL?: string;
	wltpInfo?: WltpInfo;
}

export const EecLabelSection = ({ url, pdfURL, eecURL, wltpInfo }: EecLabelSectionProps) => {
	const { isLoading } = useConfigurator();

	const impressionTrackingRef = useCallback(
		(node: HTMLDivElement) => {
			if (node !== null && !isLoading) {
				appTrackingService.summaryImpression({
					node,
					eventName: 'configurator (consumption & emission) - impression',
					componentName: 'configurator-consumption-and-emission',
				});
			}
		},
		[isLoading],
	);
	return (
		<div ref={impressionTrackingRef}>
			{AEM_MARKET_CONFIG.market.toLowerCase() === 'de' ? (
				<EecLabelSectionDE url={url!} pdfURL={pdfURL!} />
			) : (
				<EecLabelSectionDefault eecURL={eecURL} wltpInfo={wltpInfo} />
			)}
		</div>
	);
};
